import {Link, withRouter} from 'react-router-dom'
import Cookies from 'js-cookie'
import {AiFillHome} from 'react-icons/ai'
import {MdWork} from 'react-icons/md'

import './index.css'

const Header = props => {
  const logoutBtn = () => {
    Cookies.remove('jwt_token')
    const {history} = props
    history.replace('/login')
  }

  return (
    <nav className="navbar">
      <ul className="navbar-elements">
        <li className="nav-list">
          <Link to="/" className="link">
            <img
              src="https://assets.ccbp.in/frontend/react-js/logo-img.png"
              alt="website logo"
              className="website-main-logo"
            />
          </Link>
        </li>
        <li className="nav-list home-jobs-links">
          <Link to="/" className="link nav-links">
            Home
          </Link>
          <Link to="/jobs" className="link nav-links">
            Jobs
          </Link>
        </li>
        <li className="nav-list mobile-nav-links">
          <Link to="/" className="link">
            <AiFillHome className="mobile-home-logo" />
          </Link>
          <Link to="/jobs" className="link">
            <MdWork className="mobile-home-logo" />
          </Link>
          <img
            src="https://assets.ccbp.in/frontend/react-js/nxt-trendz-log-out-img.png"
            alt="nav logout"
            className="nav-logout"
            onClick={logoutBtn}
          />
        </li>
        <li className="nav-list large-device">
          <button type="button" className="logout-btn" onClick={logoutBtn}>
            Logout
          </button>
        </li>
      </ul>
    </nav>
  )
}

export default withRouter(Header)
